import { combineReducers } from '@lumapps/redux';

import { reducer as providersReducer } from './providers';

const rootReducer = combineReducers({
    providers: providersReducer,
});

export default rootReducer;
